export default function isSingleCoordValid(lat: string): boolean {
  // Expressão regular para verificar o formato da latitude
  const latRegex = /^-?([0-9]|[1-8][0-9]|90)(\.\d+)?$/;

  // Testa se a string fornecida corresponde ao formato de uma latitude válida
  return latRegex.test(lat);
}
